<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img src="../../assets/img_h5/services/banner_1.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="400"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">Services</div>
					<div class="txt">
						JTESTS offers a variety of detection<br />and analysis services.
					</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="200"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit_box">
					<div class="left"></div>
					<div class="center">
						<div class="title">Service Introduction</div>
						<div class="tit">SERVICE INTRODUCTION</div>
					</div>
					<div class="right"></div>
				</div>
				<div class="text">
					Jtests Clinical Laboratory, based in San Diego, is a leading CLlA-certifed provider of molecular pathology services, specializing in RT-PCR-based tests. Alongside, we offer comprehensive blood and urinary analysis, prioritizing molecular diagnostics. Our competitive edge lies in our innovative research capabilities for IVD product development and provision of raw materials for customer-oriented IVD technology advancement.
				</div>
				<div class="img_box">
					<img src="../../assets/img_h5/services/block_1.webp" />
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				Serving Southern California, we're at the forefront of reliable, personalized patient care and transformative diagnostic solutions.
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit_box">
					<div class="left"></div>
					<div class="center">
						<div class="title">CLIA Lab Testing</div>
						<div class="tit">CLIA LAB TESTING</div>
					</div>
					<div class="right"></div>
				</div>
				<div class="text">
					JTESTS offers a variety of detection and analysis services.
				</div>
				<div v-if="servicesList.length > 0" class="list_box">
					<div v-for="(value, index) in servicesList" :key="index" class="list_el">
						<div class="img_box">
							<img :src="weburl + value.thumb" />
						</div>
						<div class="tit">{{ value.name }}</div>
						<div class="txt_box" v-html="value.description"></div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块5-->
			<div class="block_5"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit_box">
					<div class="left"></div>
					<div class="center">
						<div class="title">Licenses</div>
						<div class="tit">LICENSES AND CERTIFICATES</div>
					</div>
					<div class="right"></div>
				</div>
				<div class="list_box">
					<div class="title">Jtests has obtained authoritative licenses and certificates.</div>
					<div class="list_el">
						<img src="../../assets/img/about/honner_1.webp" @click="showImg(require('@/assets/img/about/honner_1.webp'))" />
						<div class="tit">centers for medicare & medicaid services certificate of registration</div>
					</div>
					<div class="list_el">
						<img src="../../assets/img/about/honner_2.webp" @click="showImg(require('@/assets/img/about/honner_2.webp'))" />
						<div class="tit">clinical and public health laboratory license</div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--块4-->
			<div class="block_4"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit_box">
					<div class="left"></div>
					<div class="center">
						<div class="title">Leave a message</div>
						<div class="tit">LEAVE A MESSAGE</div>
					</div>
					<div class="right"></div>
				</div>
				<contact></contact>
			</div>
			<!--块4-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import contact from '@/component/h5/contact.vue'  //联系我们组件
import { UPURL } from '@/util/util.js';
import { ImagePreview } from 'vant';  //图片放大
export default {
	components:{
		navBox,
		footerBox,
		contact
	},
	data() {
		return {
			isLoading: true,  //界面loading
			servicesList: [],
			weburl: '',
		}
	},
	created(){
		let that = this;
		that.weburl = UPURL;
		if(sessionStorage.getItem('navData')) {
			that.servicesList = JSON.parse(sessionStorage.getItem('navData')).service_list;
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		//处理数据
		initContent(value) {
			return value.split(/\n/);
		},
		//图片放大
		showImg(value) {
			let that = this;
			ImagePreview({
				closeable: true,
				showIndicators: false,
				showIndex: false,
				images: [value]
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	font-size: 14px;
	//块5
	.block_5{
		.list_box{
			padding: 20px 20px 0 20px;
			.list_el{
				padding-top: 20px;
				text-align: center;
				.tit{
					padding: 10px 20px 0 20px;
					font-size: 16px;
				}
				img{
					width: 100%;
				}
			}
			.title{
				font-size: 16px;
			}
		}
		.tit_box{
			display: flex;
			align-items: center;
			padding: 20px;
			// padding-bottom: 5px;
			background-color: #F6F6F6;
			.center{
				flex: 1;
				text-align: center;
				.tit{
					font-size: 18px;
					color: #CCCCCC;
				}
				.title{
					font-size: 24px;
				}
			}
			.left, .right{
				width: 40px;
				height: 1px;
				background-color: #CCCCCC;
			}
		}
	}
	//块4
	.block_4{
		padding: 50px 20px;
		.tit_box{
			display: flex;
			align-items: center;
			padding-bottom: 5px;
			.center{
				flex: 1;
				text-align: center;
				.tit{
					font-size: 18px;
					color: #CCCCCC;
				}
				.title{
					font-size: 24px;
				}
			}
			.left, .right{
				width: 40px;
				height: 1px;
				background-color: #CCCCCC;
			}
		}
	}
	//块3
	.block_3{
		padding: 50px 20px;
		.list_box{
			padding-bottom: 10px;
			.list_el{
				margin-top: 20px;
				padding: 30px 20px;
				background-color: #ffffff;
				border: 1px solid #CCCCCC;
				.txt_box{
					// padding: 0px 30px 0 10px;
				}
				.tit{
					padding: 20px 0 5px 0;
					color: #E37542;
					font-size: 20px;
					text-align: center;
				}
				.img_box{
					text-align: center;
					img{
						width: 120px;
					}
				}
			}
		}
		.text{
			padding: 20px 0;
			color: #1A1819;
			font-size: 16px;
		}
		.tit_box{
			display: flex;
			align-items: center;
			.center{
				flex: 1;
				text-align: center;
				.tit{
					font-size: 18px;
					color: #CCCCCC;
				}
				.title{
					font-size: 24px;
				}
			}
			.left, .right{
				width: 40px;
				height: 1px;
				background-color: #CCCCCC;
			}
		}
	}
	//块2
	.block_2{
		padding: 30px 20px;
		background-color: #E37542;
		text-align: center;
		color: #ffffff;
		font-size: 18px;
	}
	//块1
	.block_1{
		padding: 50px 20px;
		background-color: #F6F6F6;
		.img_box{
			img{
				width: 100%;
			}
		}
		.text{
			padding: 20px 0;
			color: #1A1819;
			font-size: 16px;
		}
		.tit_box{
			display: flex;
			align-items: center;
			.center{
				flex: 1;
				text-align: center;
				.tit{
					font-size: 18px;
					color: #CCCCCC;
				}
				.title{
					font-size: 24px;
				}
			}
			.left, .right{
				width: 40px;
				height: 1px;
				background-color: #CCCCCC;
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.msg_box{
			width: 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			padding: 0 20px;
			text-align: center;
			.txt{
				font-size: 18px;
				color: #ffffff;
			}
			.tit{
				font-size: 36px;
				color: #ffffff;
			}
		}
		img{
			width: 100%;
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box ul li{
	padding-bottom: 5px;
}
>>> .main_box img{
	max-width: 100%;
	height: auto;
}
>>> .main_box th{
	padding: 12px;
	background-color: #9F58AE;
	color: #ffffff;
}
>>> .main_box td, >>> .main_box th {
	border: 1px solid #CCCCCC;
	font-size: 16px;
}
>>> .main_box table {
	max-width: 100%;
	border-collapse: collapse;
}
</style>